module.exports = __webpack_public_path__ + "assets/img/flechacategorias.c37b7021.svg";